import { useFeatureflagsStore } from '@pidz/stores';
import { type RouteLocationNormalized } from 'vue-router';

// Routes die niet meer toegankelijk zijn wanneer de migratie feature flag actief is
const restrictedRoutePathsMigration = [
  '/cv',
  '/invitations',
  '/settings',
];

// Routes die niet meer toegankelijk zijn wanneer de nieuwe app feature flag actief is
const restrictedRoutePathsNewApp = [
  '/cv',
  '/invitations',
  '/settings',
  '/dashboard',
  '/shifts',
  '/sheets',
  '/calendar',
  '/contact',
  '/faq',
  '/report',
  '/feedback',
  '/invitations',
];

export const checkFeatureFlagRedirect = async (
  to: RouteLocationNormalized
) => {
  const flagStore = useFeatureflagsStore();
  const shouldMigrate = flagStore.getStatus('pidz-2.0-released');
  const newApp = flagStore.getStatus('pidz-1.0-closed');

  // Als de feature flag niet aan staat, laat de normale navigatie toe
  if (!shouldMigrate && !newApp) {
    return true;
  }

  if (newApp) {
    // Check of de route begint met een van de restricted paths
    const isRestrictedRouteNewApp = restrictedRoutePathsNewApp.some((restrictedPath) =>
      to.path.startsWith(restrictedPath)
    );

    // Als dit een restricted route is, redirect naar de info pagina
    if (isRestrictedRouteNewApp) {
      return { name: 'new-app' };
    }
  }

  // Check of de route begint met een van de restricted paths
  const isRestrictedRouteMigration = restrictedRoutePathsMigration.some((restrictedPath) =>
    to.path.startsWith(restrictedPath)
  );

  // Als dit een restricted route is, redirect naar de info pagina
  if (isRestrictedRouteMigration) {
    return { name: 'migration-info' };
  }

  // Anders laat de navigatie toe
  return true;
};
